import React from 'react';
import Typegrophy from '../Typography';
export default function CountItem(props) {
    var total = props.total, currentPage = props.currentPage, pageSize = props.pageSize;
    var totalPage = Math.ceil(total / pageSize);
    var startNumber = currentPage > totalPage
        ? pageSize * (totalPage - 1) + 1
        : (currentPage - 1) * pageSize + 1;
    var endNumber = currentPage * pageSize > total ? total : currentPage * pageSize;
    return (React.createElement(Typegrophy, { type: "caption" },
        "\u663E\u793A\u7B2C",
        Math.max(startNumber, 0),
        "-",
        Math.max(endNumber, 0),
        "\uFF0C\u5171",
        total,
        "\u6761\u3001",
        ' ',
        totalPage,
        "\u9875"));
}
//# sourceMappingURL=CountItem.js.map